// src/theme.ts
import { createTheme } from "@mantine/core";
import "./main.css";

export const theme = createTheme({
	fontFamily: "proxima-nova",
	themeBrandColor: "#F79355",
	themeMainColor: "#052844",
	themeBlackColor: "#000000",
	// ... other theme override properties
});
